const GlobalAlerts = require('./GlobalAlerts');
const Lang = require('lang');

function AlterarMoedaPadrao() {
  const dropdownCurrency = document.querySelector('#idMoedaPadrao');

  dropdownCurrency.addEventListener('change', function() {
    const id = this.options[this.selectedIndex].value;

    sendCurrency(id)
      .then ((response) => {
        GlobalAlerts.createAndShow({
          title: Lang.get('js/src/functions/AlterarMoedaPadrao.success_title'),
          message: Lang.get('js/src/functions/AlterarMoedaPadrao.success_message'),
        })
      })
      .catch ((error) => {
        GlobalAlerts.createAndShow({
          title: Lang.get('js/src/functions/AlterarMoedaPadrao.error_title'),
          message: error.responseJSON.message,
          type: 'danger'
        })
      })
  });
};

function sendCurrency(id) {
  const ajax = $.ajax({
    method: 'POST',
    url: url(id),
    data: {moeda_id: id}
  });
  return Promise.resolve(ajax);
}

function url(id) {
  return route('app.settings.moedas.define');
}

module.exports = {
  init: AlterarMoedaPadrao,
  url: /\/settings\/empresa/
};
